import logo from '../images/logo.png'
import { Link } from 'react-router-dom'

function Navbar() {
          return(
                <nav>
                <img src={logo} alt="logo"/>
                <ul>
                    <li><Link to={'/'}>Home</Link></li>      
                    <li><Link to={'/About'}>About</Link> </li>
                    <li><Link to={'/Skills'}>Skills</Link></li>      
                    <li><Link to={'/Works'}>Works</Link></li>  
                    <li><Link to={'/Testimonials'}>Testimonials</Link></li>  
                    <li><Link to={'/Contact'}>Contact</Link></li>  
                    <li>
                        <div class="icons">
                            <a href="https://www.linkedin.com/in/craig-togarepi-97b0b1139/"><i class="fa-brands fa-linkedin"></i></a>
                            <a href="https://github.com/tristenswisss"><i class="fa-brands fa-github"></i></a>
                         </div>
        
                    </li>
                    
                </ul>
                 
               
            </nav>



          )
    
}
export default Navbar